import { Row, Col, Alert } from 'reactstrap';
import { useTranslator, useAppContext } from '@front-activerse/common-components';
import Markdown from 'markdown-to-jsx';

const DayPlanDish = ({
  name,
  recipe,
  recipeNote,
  isFirstOccurrence,
  isLastOccurrence,
  isPortioned,
  portions,
  portionsTotal,
  children,
}) => {
  const { t } = useTranslator();

  const {
    images: { star },
  } = useAppContext();

  const replaceSpanToOl = ({ children }) => (
    <ol className="recipe">
      <li>{children.slice(3)}</li>
    </ol>
  );

  return (
    <>
      <div className="dish">
        {isPortioned && (
          <span className="multi-portion-tag">{t('meal.mealTag.multiPortionDish')}</span>
        )}

        <h2 className="title-large semi-bold">{name}</h2>

        {isPortioned && (
          <Alert color="info">
            <p>
              {!isFirstOccurrence && !isLastOccurrence && (
                <span
                  className="d-block"
                  dangerouslySetInnerHTML={{
                    __html: t('dish.portion.youShouldHaveThisDish'),
                  }}
                />
              )}

              {!isFirstOccurrence && isLastOccurrence && (
                <span
                  className="d-block"
                  dangerouslySetInnerHTML={{
                    __html: t('dish.portion.youShouldHaveThisDish'),
                  }}
                />
              )}

              {portions && (
                <span
                  className="d-block"
                  dangerouslySetInnerHTML={{
                    __html: t('dish.portion.eatXportion', {
                      count: portions,
                    }),
                  }}
                />
              )}

              {isFirstOccurrence && !isLastOccurrence && (
                <span
                  className="d-block"
                  dangerouslySetInnerHTML={{
                    __html: t('dish.portion.youShouldHaveThisDishLast'),
                  }}
                />
              )}

              {!isFirstOccurrence && !isLastOccurrence && (
                <span
                  className="d-block"
                  dangerouslySetInnerHTML={{
                    __html: t('dish.portion.youShouldHaveThisDishLast'),
                  }}
                />
              )}

              {isFirstOccurrence && isLastOccurrence && portions < portionsTotal && (
                <span
                  className="d-block"
                  dangerouslySetInnerHTML={{
                    __html: t('dish.portion.rest'),
                  }}
                />
              )}
            </p>
          </Alert>
        )}

        <Row>
          <Col md="6">{children()}</Col>
          <Col md="6">
            {recipe && (
              <div className="recipe">
                <p className="semi-bold">{t('mealDetails.methodBox.title')}</p>
                <Markdown
                  start="1"
                  options={{
                    overrides: {
                      span: {
                        component: replaceSpanToOl,
                      },
                    },
                  }}
                >
                  {recipe}
                </Markdown>
              </div>
            )}
          </Col>
        </Row>
      </div>
      {recipeNote && (
        <div className="smart-tip-container">
          <div className="smart-tip">
            <p className="semi-bold text-text-main-color">
              <img src={star} alt="" style={{ width: '24px' }} className="me-2" />
              {t('mealDetails.smartTipBox.title')}
            </p>
            <p className="mb-0 small">{recipeNote}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default DayPlanDish;
